import React from 'react';
import { Link } from 'react-router-dom';
import { MobileLayout } from '../../components/MobileLayout';
import { Card, CardHeader, CardContent } from '../../components/ui/Card';
import { MatchReason } from '../../components/MatchReason';
import { ClipboardList, Layers, ArrowRight, TrendingUp, Clock, Zap, Users } from 'lucide-react';
import { useMaintenance } from '../../context/MaintenanceContext';
const jobStatusLabel: Record<string, {
  label: string;
  cls: string;
}> = {
  da_accettare: {
    label: 'Da accettare',
    cls: 'bg-amber-50 text-amber-700 border-amber-200'
  },
  accettata: {
    label: 'Accettata',
    cls: 'bg-muted text-muted-foreground border-border'
  },
  in_corso: {
    label: '● In corso',
    cls: 'bg-coral/5 text-coral border-coral/20'
  },
  completata: {
    label: 'Completata',
    cls: 'bg-emerald-50 text-emerald-700 border-emerald-200'
  }
};
export function ManDashboardPage() {
  const {
    jobs,
    opportunities,
    requests,
    openAggregations
  } = useMaintenance();
  const daAccettare = jobs.filter(j => j.status === 'da_accettare');
  const oggi = jobs.filter(j => j.date === 'Oggi');
  const urgentRequests = requests.filter(r => r.urgency === 'urgente' && r.status === 'in_ricerca');
  const ownAggregating = requests.filter(r => r.status === 'in_attesa_aggregazione');
  const aggregationsCount = openAggregations.length + ownAggregating.length;
  const highlight = opportunities[0];
  const stats = [{
    label: 'Interventi urgenti',
    value: `${urgentRequests.length}`,
    to: '/man/opportunita'
  }, {
    label: 'Raggruppamenti',
    value: `${aggregationsCount}`,
    to: '/man/opportunita'
  }, {
    label: 'Incarichi oggi',
    value: `${oggi.length}`,
    to: '/man/incarichi'
  }, {
    label: 'Da accettare',
    value: `${daAccettare.length}`,
    to: '/man/incarichi'
  }];
  return <MobileLayout data-id="element-3198">
      <div className="mb-6" data-id="element-3199">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-3200">
          Ciao, Manutentore 👋
        </h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6" data-id="element-3201">
        {stats.map(s => <Link key={s.label} to={s.to} className="bg-white border border-border rounded-xl p-4 hover:border-coral/50 hover:shadow-sm transition-all" data-id="element-3202">
            <div className="text-2xl font-bold text-foreground" data-id="element-3203">{s.value}</div>
            <div className="text-xs text-muted-foreground mt-1" data-id="element-3204">{s.label}</div>
          </Link>)}
      </div>

      {/* Highlight Card */}
      {urgentRequests.length > 0 ? <Link to="/man/opportunita" className="block bg-white border border-border rounded-xl p-5 mb-6 hover:border-coral/50 hover:shadow-sm transition-all" data-id="element-3205">
          <div className="flex items-start gap-4" data-id="element-3206">
            <div className="w-12 h-12 rounded-xl bg-coral/10 flex items-center justify-center flex-shrink-0" data-id="element-3207">
              <Zap size={24} className="text-coral" data-id="element-3208" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-3209">
              <div className="flex items-center gap-2 mb-1" data-id="element-3210">
                <h2 className="text-sm font-semibold text-foreground" data-id="element-3211">
                  {urgentRequests.length}{' '}
                  {urgentRequests.length === 1 ? 'intervento urgente' : 'interventi urgenti'}{' '}
                  da assegnare
                </h2>
                <span className="text-[10px] font-medium text-coral bg-coral/10 px-1.5 py-0.5 rounded-full" data-id="element-3212">
                  URGENTE
                </span>
              </div>
              <p className="text-xs text-muted-foreground" data-id="element-3213">
                Richieste senza fornitore in zona — rispondi subito per
                candidarti.
              </p>
              <div className="flex items-center gap-1 text-sm font-medium text-coral mt-2" data-id="element-3214">
                Vedi richieste urgenti
                <ArrowRight size={15} data-id="element-3215" />
              </div>
            </div>
          </div>
        </Link> : aggregationsCount > 0 ? <Link to="/man/opportunita" className="block bg-white border border-border rounded-xl p-5 mb-6 hover:border-teal-deep/50 hover:shadow-sm transition-all" data-id="element-3216">
          <div className="flex items-start gap-4" data-id="element-3217">
            <div className="w-12 h-12 rounded-xl bg-teal-deep/10 flex items-center justify-center flex-shrink-0" data-id="element-3218">
              <Users size={24} className="text-teal-deep" data-id="element-3219" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-3220">
              <h2 className="text-sm font-semibold text-foreground mb-1" data-id="element-3221">
                {aggregationsCount}{' '}
                {aggregationsCount === 1 ? 'raggruppamento' : 'raggruppamenti'}{' '}
                in zona
              </h2>
              <p className="text-xs text-muted-foreground" data-id="element-3222">
                Gruppi di interventi in formazione: candidati per servirli
                insieme e ottimizzare gli spostamenti.
              </p>
              <div className="flex items-center gap-1 text-sm font-medium text-teal-deep mt-2" data-id="element-3223">
                Vedi raggruppamenti
                <ArrowRight size={15} data-id="element-3224" />
              </div>
            </div>
          </div>
        </Link> : highlight ? <Link to="/man/opportunita" className="block bg-white border border-border rounded-xl p-5 mb-6 hover:border-coral/50 hover:shadow-sm transition-all" data-id="element-3225">
          <div className="flex items-start gap-4" data-id="element-3226">
            <div className="w-12 h-12 rounded-xl bg-coral/10 flex items-center justify-center flex-shrink-0" data-id="element-3227">
              <Layers size={24} className="text-coral" data-id="element-3228" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-3229">
              <div className="flex items-center gap-2 mb-1" data-id="element-3230">
                <h2 className="text-sm font-semibold text-foreground" data-id="element-3231">
                  {highlight.jobsCount} interventi {highlight.trade}{' '}
                  raggruppabili
                </h2>
                <span className="text-[10px] font-medium text-coral bg-coral/10 px-1.5 py-0.5 rounded-full" data-id="element-3232">
                  NUOVO
                </span>
              </div>
              <p className="text-xs text-muted-foreground mb-1.5" data-id="element-3233">
                {highlight.zone} · {highlight.window}
              </p>
              <MatchReason distanceKm={highlight.distanceKm} efficiency={highlight.efficiency} peopleInZone={highlight.hostsInZone} peopleLabel="host in zona" data-id="element-3234" />
              <div className="flex items-center gap-1 text-sm font-medium text-coral mt-2" data-id="element-3235">
                Vedi opportunità
                <ArrowRight size={15} data-id="element-3236" />
              </div>
            </div>
          </div>
        </Link> : null}

      <Card className="mb-6" data-id="element-3237">
        <CardHeader icon={<ClipboardList size={15} className="text-muted-foreground" data-id="element-3239" />} title="Incarichi di oggi" action={<Link to="/man/incarichi" className="text-xs font-medium text-coral hover:underline" data-id="element-3240">
              Vedi tutti
            </Link>} data-id="element-3238" />
        <CardContent data-id="element-3241">
          {oggi.length === 0 && <p className="text-sm text-muted-foreground text-center py-4" data-id="element-3242">
              Nessun incarico per oggi.
            </p>}
          <ul className="space-y-3" data-id="element-3243">
            {oggi.map(j => <li key={j.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-3244">
                <div className="min-w-0" data-id="element-3245">
                  <div className="text-sm font-semibold text-foreground truncate" data-id="element-3246">
                    {j.title}
                  </div>
                  <div className="flex items-center gap-2 text-xs text-muted-foreground mt-0.5" data-id="element-3247">
                    <Clock size={12} data-id="element-3248" />
                    {j.time}
                    <span data-id="element-3249">·</span>
                    {j.zone}
                  </div>
                </div>
                <span className={`text-[10px] font-medium px-2 py-1 rounded-full border flex-shrink-0 ${jobStatusLabel[j.status].cls}`} data-id="element-3250">
                  {jobStatusLabel[j.status].label}
                </span>
              </li>)}
          </ul>
        </CardContent>
      </Card>

      <Link to="/man/guadagni" className="block bg-white border border-border rounded-xl p-5 hover:border-coral/50 hover:shadow-sm transition-all" data-id="element-3251">
        <div className="flex items-center justify-between" data-id="element-3252">
          <div className="flex items-center gap-3" data-id="element-3253">
            <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center" data-id="element-3254">
              <TrendingUp size={20} className="text-navy" data-id="element-3255" />
            </div>
            <div data-id="element-3256">
              <div className="text-sm font-semibold text-foreground" data-id="element-3257">
                Guadagni stimati questo mese
              </div>
              <div className="text-xs text-muted-foreground" data-id="element-3258">
                Su interventi confermati e completati
              </div>
            </div>
          </div>
          <div className="text-lg font-bold text-coral" data-id="element-3259">€1.240</div>
        </div>
      </Link>
    </MobileLayout>;
}